export const mainNav = [
  { label: "Verlichting", to: "/shop?categorie=Verlichting" },
  { label: "Gepersonaliseerd", to: "/shop?categorie=Gepersonaliseerd" },
  { label: "Maatwerk", to: "/#maatwerk" },
];

export const popularIds = ["koraal", "flow", "fotolamp-zw", "naamcirkel"];

export const announcements = [
  "Ontworpen en geproduceerd in Nederland",
  "Personaliseer je cadeau met naam, tekst of foto",
  "Lampen met premium Creative-Cables voet en snoer",
];

export const footerColumns = [
  {
    title: "Shop",
    links: [
      { label: "Verlichting", to: "/shop?categorie=Verlichting" },
      { label: "Woondecoratie", to: "/shop?categorie=Woondecoratie" },
      { label: "Gepersonaliseerd", to: "/shop?categorie=Gepersonaliseerd" },
      { label: "Alle producten", to: "/shop" },
    ],
  },
  {
    title: "Service",
    links: [
      { label: "Winkelwagen", to: "/winkelwagen" },
      { label: "Maatwerk aanvragen", to: "/#maatwerk" },
      { label: "Verzending & levertijd", to: "/" },
      { label: "Veelgestelde vragen", to: "/" },
    ],
  },
  {
    title: "Koers Design",
    links: [
      { label: "Over ons", to: "/" },
      { label: "Werkwijze", to: "/#werkwijze" },
      { label: "Ontwerp je Flexi", to: "/" },
      { label: "TikTok acties", to: "/" },
    ],
  },
];
